import { createAction } from '@reduxjs/toolkit';

export const FETCH_CRM_STATUS = 'FETCH_CRM_STATUS';
export const fetchCrmStatusAction = createAction(FETCH_CRM_STATUS);